module.exports = __webpack_public_path__ + "static/Roboto-Medium-58aef543c97bbaf6a9896e8484456d98.ttf";